import React from "react";
import { compose } from "recompose";
import { DocumentRenderer } from "components";
import { Trans } from "react-i18next";
import { formatCurrency, formatDate, convertUTCToLocal, CurrencySymbol } from "services/util";
import LineItems from "./LineItems";
import { withSelectedOrganisation } from "../../components/withSelectedOrganisation";
import MainHeader from "./MainHeader";
import HeaderData from "./HeaderData";
import withData from "./withData";

export const SpendMoney = ({
  item,
  contact,
  organisation,
  taxRates,
  settings,
  t,
  ...props
}) => (
  <DocumentRenderer {...props}>
    <div className="container-fluid m-0 p-0">
      <MainHeader item={item} company={organisation} client={contact} taxRates={taxRates} t={t} settings={settings} doc_name={item.Type} logo={props.selectedOrganisation.logo} >
        <HeaderData className="mb-1" label={`Payment Date`} value={item.DateString} />
        <HeaderData className="mb-1" label={`Time`} value={convertUTCToLocal(item.UpdatedDateUTC)} />
        <HeaderData className="mb-1" label="Reference" value={item.Reference || item.InvoiceNumber} />
      </MainHeader>
      
      <div className="d-flex justify-content-between mb-5">
        <div>
          <div className="border-dark border-top border-bottom p-2 font-weight-bold d-flex justify-content-end">
            <span className="mr-5">
              <Trans>Total</Trans> <CurrencySymbol currency={item.CurrencyCode}/>
            </span>{" "}
            <span>{formatCurrency(item.Total)}</span>
          </div>
        </div>
      </div>
      <LineItems invoice={item} taxRates={taxRates} />
      <hr />
      <h4>
        <Trans>Signature:</Trans>
      </h4>
      <div
        className="border-bottom border-dark d-inline-block"
        style={{ width: "20rem", marginTop: "4rem", height: "1px" }}
      />
    </div>
  </DocumentRenderer>
);

const enhance = compose(withData, withSelectedOrganisation());

export default enhance(SpendMoney);
